import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'
import sxs from './_styles/HelpCenterMainSx'
import HelpCenterCardsContainer from './HelpCenterCardsContainer'

const HelpCenterMain: React.FC = () => (
    <Box sx={sxs.helpCenterMain}>
        <Typography sx={sxs.helpCenterMainTitle}>Mes ressources TokTokDoc</Typography>
        <HelpCenterCardsContainer
            contentType={{
                helpCenterAndTutorials: true,
                newsFeed: true,
            }}
        />
    </Box>
)

export default HelpCenterMain
